module.exports.config = {
  "declarative": true,
  "render-module": {
    "name": "PieceProductBannerRenderModule",
    "path": "front/piece-product-banner-render.module"
  },
  "definition": {
    "type": "product",
    "name": "PieceProductBannerDefinition",
    "group": "Components",
    "availablePlatforms": ["web"],
    "description": "Producto Banner",
    "fields": [
      {
        "name": "productId",
        "label": "Product",
        "type": "product",
        "mandatory": true,
        "jsonPath": "product.productId"
      },
      {
        "name": "main",
        "type": "productSettingsSelector",
        "jsonPath": "main"
      },
      {
        "name": "displayInspirationalText",
        "label": "Mostrar texto inspiracional",
        "type": "groupToggleable",
        "flattenFields": true,
        "fields": [
          {
            "name": "inspirationalText",
            "label": "Texto inspiracional",
            "type": "richText"
          }
        ]
      },
      {
        "name": "customStyles",
        "label": "Estilos personalizados",
        "type": "boolean",
        "defaultValue": false
      },
      {
        "label": "Mostrar en producto",
        "type": "groupCollapsable",
        "flattenFields": true,
        "isFolded": true,
        "fields":[
        {
          "name": "displayProductName",
          "label": "Nombre",
          "type": "groupToggleable",
          "flattenFields": true,
          "fields": [
            {
              "name": "productName",
              "label": "Nombre del producto",
              "type": "richText"
            }
          ]
        },
        {
          "name": "displayProductDescription",
          "label": "Descripción",
          "type": "groupToggleable",
          "flattenFields": true,
          "fields": [
            {
              "name": "productDescription",
              "label": "Descripción del producto",
              "type": "richText"
            }
          ]
        },
        {
          "name": "prices",
          "label": "Precios",
          "type": "prices"
        },
        {
          "name": "displayProductAddToCart",
          "label": "Botón de 'Añadir al carro'",
          "type": "productPurchaseOptions"
        }
       ]
      },
      {
        "label": "Imagen",
        "type": "groupCollapsable",
        "flattenFields": true,
        "isFolded": true,
        "fields":[
        {
          "name": "customImage",
          "label": "Usar imagen personalizada",
          "type": "groupToggleable",
          "defaultValue": true,
          "flattenFields": true,
          "fields": [
            {
              "name": "Image",
              "type": "linkedImages",
              "mandatory": false
            },
            {
              "name": "preloadImage",
              "label": "Precargar imagen en SSR",
              "type": "boolean",
              "defaultValue": false,
              "isExcluded": true
            }
          ]
        },
        {
          "name": "extraImage",
          "label": "Añadir una imagen extra",
          "type": "groupToggleable",
          "flattenFields": true,
          "fields": [
            {
              "name": "extra",
              "type": "productSettingsSelector",
              "jsonPath": "extra"
            }
          ]
        },
        {
          "name": "objectPosition",
          "label": "Posición de la imagen",
          "type": "optionsSelect",
          "section": "styles",
          "defaultValue": "center",
          "values": [
            { "value": "center", "label": "Centro" },
            { "value": "top", "label": "Arriba" },
            { "value": "bottom", "label": "Abajo" }
          ]
        },
        {
          "name": "objectFit",
          "label": "Proporción de la imagen",
          "type": "options",
          "section": "styles",
          "defaultValue": "cover",
          "values": [
            { "value": "contain", "label": "Contain" },
            { "value": "cover", "label": "Cover" }
          ]
        }
       ]
      },
      {
        "name": "productVariants",
        "label": "Slides con variantes",
        "type": "slidesSelector",
      },
      {
        "type": "groupCollapsable",
        "name": "analytics",
        "label": "Analítica",
        "fields": [
          {
            "name": "origin", 
            "label": "Origin",
            "placeholder": "Origin",
            "type": "plainText",
            "mandatory": false 
          },
          {
            "name": "provider", 
            "label": "Provider",
            "placeholder": "Provider",
            "type": "plainText",
            "mandatory": false 
          },
          {
            "name": "strategy", 
            "label": "Strategy",
            "placeholder": "Strategy",
            "type": "plainText",
            "mandatory": false 
          },
          {
            "name": "objective", 
            "label": "Objective",
            "placeholder": "Objective",
            "type": "plainText",
            "mandatory": false 
          },
          {
            "name": "salesAttribution",
            "label": "Atribución de venta",
            "type": "options",
            "defaultValue": "01",
            "isExcluded": true,
            "values": [
              {
                "label": "Home",
                "value": "01"
              },
              {
                "label": "StradiLooks UGC",
                "value": "30"
              }
            ]
          },
        ]
      }
    ]
  }
};
